/* PrinterCart spelling + similar-match engine.
   Learns words and model codes from the live catalogue (all products),
   corrects typos ("epsom l3120" -> "Epson L3210"), and finds close matches. */
(function(){
if(window.PCF)return;
var KEY='pcf-idx-v3',TTL=6*36e5,BASE='/collections/all?view=pcindex&page=';
var ITEMS=null,VOC=null,BYLEN=null,loading=null;
var STOP={'for':1,'my':1,'the':1,'and':1,'with':1,'to':1,'of':1,'in':1,'on':1,'a':1,'an':1,'i':1,'is':1,'it':1,'me':1,'need':1,'want':1,'looking':1,'please':1,'pls':1,'any':1,'have':1,'do':1,'you':1,'one':1,'new':1,'buy':1,'price':1,'how':1,'much':1,'what':1,'which':1,'some':1,'get':1,'can':1,'from':1,
 /* Singlish and Tamil in English letters */
 'mila':1,'mile':1,'ganan':1,'gana':1,'kiyada':1,'kiyda':1,'keeyada':1,'eka':1,'ekak':1,'ekata':1,'ona':1,'oni':1,'onna':1,'denna':1,'tiyenawada':1,'thiyenawada':1,'tiyanawada':1,'thiyanawada':1,'mage':1,'mata':1,'api':1,'apita':1,'kohomada':1,'mokakda':1,'tiyeda':1,'thiyeda':1,'genna':1,'ganna':1,'puluwanda':1,
 'mai':1,'vilai':1,'evvalavu':1,'enna':1,'irukka':1,'irukkuma':1,'venum':1,'vendum':1,'kidaikkuma':1,'enakku':1,'kodunga':1,'thevai':1};
var SYN={lazer:'laser',lasor:'laser',catridge:'cartridge',cartrige:'cartridge',catrige:'cartridge',cartage:'cartridge',cartridges:'cartridge',color:'colour',colours:'colour',colors:'colour',inks:'ink',toners:'toner',tonner:'toner',tonor:'toner',printers:'printer',scanners:'scanner',ribbons:'ribbon',cannon:'canon',epsom:'epson',bottles:'bottle',drums:'drum',tapes:'tape'};
var TYPO={lazer:1,lasor:1,catridge:1,cartrige:1,catrige:1,cartage:1,tonner:1,tonor:1,cannon:1,epsom:1};
var BRANDS=['hp','canon','epson','brother','lexmark','ricoh','kyocera','toshiba','panasonic','fujifilm','xerox','samsung','pantum','dymo','avery','avalon','eco'];

function low(s){return String(s==null?'':s).toLowerCase();}
function words(s){return low(s).replace(/&/g,' ').replace(/[^a-z0-9\-.\s]/g,' ').split(/\s+/).map(function(w){return w.replace(/^[-.]+|[-.]+$/g,'');}).filter(Boolean);}
function sq(w){return w.replace(/[-.]/g,'');}
function pieces(w){return w.match(/[a-z]+|\d+/g)||[];}
function allow(w){var n=w.length,d=n<=2?0:n<=4?1:n<=8?2:3;if(/\d/.test(w))d=Math.min(d,1);return d;}
function dist(a,b,max){
 if(a===b)return 0;var la=a.length,lb=b.length;if(Math.abs(la-lb)>max)return max+1;
 var p2=null,p=[],c,i,j;for(j=0;j<=lb;j++)p[j]=j;
 for(i=1;i<=la;i++){c=[i];var m=i;
  for(j=1;j<=lb;j++){var v=Math.min(p[j]+1,c[j-1]+1,p[j-1]+(a.charCodeAt(i-1)===b.charCodeAt(j-1)?0:1));
   if(i>1&&j>1&&a[i-1]===b[j-2]&&a[i-2]===b[j-1])v=Math.min(v,p2[j-2]+1);c[j]=v;if(v<m)m=v;}
  if(m>max)return max+1;p2=p;p=c;}
 return p[lb];}

/* ---------- index ---------- */
function addVoc(raw,w,n){var k=sq(w);if(k.length<2)return;var e=VOC[k];if(!e){e=VOC[k]={n:0,d:raw};(BYLEN[k.length]=BYLEN[k.length]||[]).push(k);}e.n+=n;}
function tokset(str,weight,into){
 String(str).split(/\s+/).forEach(function(raw){var w=low(raw).replace(/[^a-z0-9\-.]/g,'').replace(/^[-.]+|[-.]+$/g,'');if(!w)return;
  var raw2=raw.replace(/^[^A-Za-z0-9]+|[^A-Za-z0-9]+$/g,'');
  var k=sq(w);into[k]=1;if(weight)addVoc(raw2,w,weight);
  var ps=pieces(k);if(ps.length>1)ps.forEach(function(x){if(x.length>=2||/\d/.test(x)){into[x]=1;if(weight)addVoc(/\d/.test(x)?x:x.charAt(0).toUpperCase()+x.slice(1),x,weight*.5);}});});}
function build(items){
 VOC={};BYLEN={};
 items.forEach(function(it){var T={},G={};
  tokset(it.t,3,T);
  String(it.g||'').split('|').forEach(function(tag){tokset(tag,1,G);});
  tokset(it.ty||'',1,T);
  it._t=T;it._g=G;});
 ITEMS=items;}
function load(){
 if(ITEMS)return Promise.resolve(ITEMS);if(loading)return loading;
 try{var c=JSON.parse(localStorage.getItem(KEY)||'null');if(c&&Date.now()-c.at<TTL&&c.items&&c.items.length){build(c.items);return Promise.resolve(ITEMS);}}catch(e){}
 function page(n){return fetch(BASE+n,{credentials:'same-origin'}).then(function(r){return r.text();}).then(function(t){return JSON.parse(t);});}
 loading=page(1).then(function(j){var all=j.items||[],rq=[];for(var k=2;k<=(j.pages||1)&&k<=30;k++)rq.push(page(k));
  return Promise.all(rq).then(function(rs){rs.forEach(function(x){all=all.concat(x.items||[]);});
   try{localStorage.setItem(KEY,JSON.stringify({at:Date.now(),items:all.map(function(i){return {t:i.t,h:i.h,p:i.p,i:i.i,v:i.v,a:i.a,ty:i.ty,g:i.g,r:i.r,f:i.f};})}));}catch(e){}
   build(all);return ITEMS;});}).catch(function(e){loading=null;throw e;});
 return loading;}

/* ---------- spelling ---------- */
function near(k,max){var best=[],bd=max+1;
 for(var L=Math.max(2,k.length-max);L<=k.length+max;L++){var arr=BYLEN[L];if(!arr)continue;
  for(var i=0;i<arr.length;i++){var w=arr[i];if(/\d/.test(k)!==/\d/.test(w))continue;
   var d=dist(k,w,Math.min(max,bd));if(d>max||d>bd)continue;
   if(d<bd){bd=d;best=[];}best.push(w);}}
 best.sort(function(a,b){return (b.charAt(0)===k.charAt(0))-(a.charAt(0)===k.charAt(0))||VOC[b].n-VOC[a].n;});
 return best;}
function disp(k){var e=VOC[k];if(!e)return k;var d=e.d;if(/^[a-z]+$/.test(d))d=d.charAt(0).toUpperCase()+d.slice(1);if(k==='hp')d='HP';return d;}
function correct(q){
 if(!VOC)return {text:String(q||'').trim(),changed:false,alts:[],toks:words(q).map(sq)};
 var ws=words(q),out=[],toks=[],changed=false,firstAlts=null,firstIdx=-1;
 ws.forEach(function(w){var k=sq(w);
  if(SYN[k]){if(TYPO[k])changed=true;k=SYN[k];w=k;}
  if(STOP[k]||k.length<2){out.push(w);if(!STOP[k])toks.push(k);return;}
  if(VOC[k]){out.push(disp(k));toks.push(k);return;}
  var ps=pieces(k);
  if(ps.length>1&&ps.every(function(x){return VOC[x];})){out.push(ps.map(disp).join(' '));toks.push.apply(toks,ps);return;}
  var c=near(k,allow(k));
  if(c.length){out.push(disp(c[0]));toks.push(c[0]);changed=true;if(!firstAlts){firstAlts=c.slice(1,3);firstIdx=out.length-1;}return;}
  if(ps.length>1){var ok=true,fx=ps.map(function(x){if(VOC[x])return x;var n=near(x,allow(x));if(n.length){changed=true;return n[0];}ok=false;return x;});
   if(ok){out.push(fx.map(disp).join(' '));toks.push.apply(toks,fx);return;}}
  out.push(w);toks.push(k);});
 out=out.map(function(o,i){return (/^[A-Za-z]{2,3}$/.test(o)&&/^\d/.test(out[i+1]||''))?o.toUpperCase():o;});
 var text=out.join(' ');
 var alts=(firstAlts||[]).map(function(a){var o=out.slice();o[firstIdx]=disp(a);return o.join(' ');});
 return {text:text,changed:changed,alts:alts,toks:toks};}

/* ---------- similar products ---------- */
function search(q,o){o=o||{};if(!ITEMS)return [];
 var c=correct(q),qt=c.toks.filter(function(t){return !STOP[t]&&t.length>=1;});if(!qt.length)return [];
 var known=qt.filter(function(t){return VOC[t]||/^\d+$/.test(t);});var use=known.length?known:qt;
 var out=[];
 ITEMS.forEach(function(it){if(o.f&&!o.f(it))return;var s=0,miss=0;
  use.forEach(function(t){var v=0;
   if(it._t[t])v=1;else if(it._g[t])v=.8;
   else if(t.length>=3){for(var k in it._t){if(k.indexOf(t)===0){v=.85;break;}}if(!v)for(k in it._g){if(k.indexOf(t)===0){v=.7;break;}}}
   if(!v)miss++;s+=v;});
  var need=use.length>=3?1:0;if(miss>need)return;
  var sc=s/use.length+(it.a?.04:0)+(it._t[use[0]]?.03:0);
  if(sc>=(o.min||.6))out.push({it:it,s:sc});});
 out.sort(function(a,b){return b.s-a.s||a.it.p-b.it.p;});
 return out.slice(0,o.limit||12).map(function(x){return x.it;});}

/* ---------- helpers for chat answers ---------- */
var listCache={};
function fixWords(text,list){var key=list.join(','),L=listCache[key];
 if(!L){L={set:{},by:{}};list.forEach(function(w){L.set[w]=1;(L.by[w.length]=L.by[w.length]||[]).push(w);});listCache[key]=L;}
 return low(text).replace(/[a-z]{4,}/g,function(w){if(L.set[w]||STOP[w])return w;var max=w.length<=6?1:2,best=null,bd=max+1;
  for(var n=w.length-max;n<=w.length+max;n++){(L.by[n]||[]).forEach(function(x){var d=dist(w,x,max);if(d<bd){bd=d;best=x;}});}
  return best||w;});}
function looksLikeProduct(text){var t=low(text);
 if(/\b(?=[a-z]*\d)(?=\d*[a-z])[a-z0-9-]{3,}\b/.test(t)&&!/^\s*[\d.,]+\s*(k|l|lac|lakh)\s*$/.test(t)&&!/\d+\s*k\b/.test(t))return true;
 if(/\d/.test(t)&&!/(page|day|week|month|lakh|lac|thousand|budget|rs|around|about|under|k\b)/.test(t))return true;
 if(/\b(toner|ink|cartridge|catridge|ribbon|drum|bottle|tape|refill)s?\b/.test(t))return true;
 if(/(ඉන්ක්|ටෝනර්|ප්‍රින්ටර්|කාට්‍රිජ්|மை|டோனர்|பிரிண்டர்|கார்ட்ரிட்ஜ்)/.test(text))return true;
 return words(t).some(function(w){return BRANDS.some(function(b){return w===b||(b.length>=5&&dist(w,b,1)<=1);});});}
function isReady(){return !!ITEMS;}

window.PCF={items:function(){return ITEMS;},load:load,isReady:isReady,correct:correct,search:search,fixWords:fixWords,looksLikeProduct:looksLikeProduct,dist:dist};
})();
